<template>
	<span :title="addressString">
		<!-- <input type="text" class="tbl_int" :value="value" :placeholder="ph" autocomplete="off" style="width:78px;" @input="updateValue" @blur="search(false)" @keyup.enter="enter_search()" :disabled="disabled" /> -->
		<input
			type="text"
			v-if="!typeahead"
			class="tbl_int"
			:value="value"
			:placeholder="ph"
			autocomplete="off"
			style="width:78px;"
			@input="updateValue"
			@blur="search(false)"
			@keyup.enter="keyEnter($event)"
			:disabled="disabled"
			:readonly="disableInput"
			ref="keyword"
			@focus="$event.target.select()"
		/>
		<!-- <input type="text" class="tbl_int" :value="value" :placeholder="ph" autocomplete="off" style="width:78px;" @input="updateValue" @keyup.enter="enter_search()" :disabled="disabled" /> -->
		<span v-if="typeahead" style="display:inline-block;vertical-align:middle;width:210px;">
			<autocomplete ref="ac" :source="acSource" :credentials="acCredentials" @selected="selectFromAc" :results-display="acDisplay" :placeholder="ph || 'Search'" />
		</span>
		<button :disabled="disabled" @click="selectPartner()">...</button>
		<!-- <span v-if="showName" class="int_type2"><input v-model="name" v-bind:style="'width:' + nameWidth + 'px;'" class="tbl_int sm_int" readonly @click="selectPartner()"/></span> -->
		<span v-if="showName" class="int_type2"
			><input
				:value="showFullName ? name + ' / ' + full_name : name"
				:title="showFullName ? name + ' / ' + full_name : name"
				v-bind:style="'width:' + nameWidth + 'px;'"
				class="tbl_int sm_int"
				readonly
				:disabled="disabled"
				@click="nameClick()"
				@focus="$event.target.select()"
		/></span>

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Select Partner</template>
			<template slot="body">
				<PartnerPopup :initialKeyword="value" :customerOnly="customerOnly" :vendorOnly="vendorOnly" :limitRecentPO="limitRecentPO" v-on:close="closeModal()" @set-partner="setPartner" />
			</template>
		</Modal>
	</span>
</template>

<script>
import { apiSelectPartner } from '@/api/partner/index.js';
import PartnerPopup from '@/components/common/PartnerPopup';
import Modal from '@/components/common/Modal';

export default {
	data: function() {
		return {
			//code: null,
			name: this.initialName,
			full_name: null,
			// dl: null,
			// desc: null,
			showModal: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		// #3252 : 응답 시점 세션의 회사를 본다. Vuex 캐시가 아니라 vue-session 값이 기준이다.
		stateScoped: function() {
			var u = this.$session.get('user');
			return !!u && u.company_id === 'beautyplus';
		},
		// 인증 경로로 갈 때만 쿠키를 실어 보낸다. 기존 경로는 종전 동작(same-origin)을 유지한다.
		acCredentials: function() {
			return this.stateScoped ? 'include' : 'same-origin';
		},
	},
	components: {
		PartnerPopup,
		Modal,
	},
	props: {
		value: String,
		initialName: String,
		addressString: String,

		ph: String,
		showName: {
			type: Boolean,
			default: true,
		},
		showFullName: {
			type: Boolean,
			default: false,
		},
		nameWidth: {
			type: Number,
			default: 300,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		disableInput: {
			type: Boolean,
			default: false,
		},
		customerOnly: {
			type: Boolean,
			default: false,
		},
		vendorOnly: {
			type: Boolean,
			default: false,
		},
		activeOnly: {
			type: Boolean,
			default: false,
		},
		limitRecentPO: {
			type: Boolean,
			default: false,
		},
		nameClickToPopup: {
			type: Boolean,
			default: true,
		},
		typeahead: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		initialName: function(newVal) {
			//console.log(newVal);
			this.name = newVal;
		},
		value: function(newVal) {
			if (!newVal) this.name = null;
			//console.log(newVal);
			//this.name = newVal;
		},
	},
	methods: {
		async keyEnter(e) {
			if (this.user.company_id == 'newjigu') {
				await this.search(true);
				e.target.select();
			} else e.target.blur();
			// ? $event.target.blur() : $event.target.select()"
		},
		nameClick() {
			if (this.nameClickToPopup) this.selectPartner();
		},
		updateValue: function(event) {
			this.$emit('input', event.target.value);
			//this.value = event.target.value;
		},
		acSource(input) {
			// #3252 : beautyplus 는 조회자별 State 제한이 걸리므로 세션을 쓰는 인증 경로로 간다.
			// 기존 acPartnerList 는 인증 예외라 조회자를 알 수 없다. 다른 회사는 종전 경로 그대로다.
			var url = this.stateScoped ? process.env.VUE_APP_API_URL + '/api/partner/acPartnerListAuth?keyword=' + input : process.env.VUE_APP_API_URL + '/api/partner/acPartnerList?company_id=' + this.user.company_id + '&keyword=' + input;
			if (this.customerOnly) url += '&customer_only=true';
			if (this.vendorOnly) url += '&vendor_only=true';
			return url;
		},
		acDisplay(result) {
			return result.name + ' (' + result.code + ')';
		},
		async selectFromAc(c) {
			this.$refs.ac.clear();
			var code = c.selectedObject.code;
			var param = { code: code };
			if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;
			if (this.customerOnly) param.customer_only = true;
			if (this.vendorOnly) param.vendor_only = true;
			const { data } = await apiSelectPartner(param);
			if (data.partner) {
				if (this.activeOnly && data.partner.active_yn == 'N') {
					this.name = null;
					this.$toast.error('"' + code + '" (' + data.partner.name + ') is Not Active');
				} else {
					await this.setPartner(data.partner);
				}
			} else {
				this.$toast.error('Partner Code of "' + code + '" Not Found');
			}
		},
		focus() {
			var el = this.$el.querySelector('input');
			if (el) el.focus();
		},
		selectPartner() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		async setPartner(partner, enter_tag) {
			console.log(enter_tag);
			//console.log(partner.code, partner.name);
			// this.code = partner.code;
			this.name = partner.name;
			this.full_name = partner.full_name;

			this.$emit('input', partner.code);
			//this.$emit('set-name', partner.name);
			this.$emit('set-partner', partner);
		},
		async enter_search() {
			await this.search(true);
			//if ()
		},
		async search(enter_tag) {
			if (!this.value) return;
			var keyword = this.value.trim();
			if (!keyword) return;

			//console.log('search....', '*' + keyword + '*');
			var param = {
				code: keyword,
				//include_specialty: true,
			};
			if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;
			//console.log(param);
			//if (this.activeOnly) param.active_yn = 'Y';
			if (this.customerOnly) param.customer_only = true;
			if (this.vendorOnly) param.vendor_only = true;

			const { data } = await apiSelectPartner(param);

			if (data.partner) {
				//console.log(data.partner);
				if (this.activeOnly && data.partner.active_yn == 'N') {
					this.name = null;
					//this.$emit('input', null);
					this.$toast.error('"' + keyword + '" (' + data.partner.name + ') is Not Active');
				} else {
					await this.setPartner(data.partner, enter_tag);
				}
			} else {
				this.name = null;
				//this.$emit('input', null);
				this.$toast.error('Partner Code of "' + keyword + '" Not Found');
				//this.$refs.keyword.select();
			}
		},
		async init() {
			if (this.showFullName) {
				const { data } = await apiSelectPartner({ code: this.value });

				if (data.partner) {
					this.name = data.partner.name;
					this.full_name = data.partner.full_name;
				}
			}
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
